import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../resources/dark-logo.png';
import simpleLogo from '../resources/logo-simple.png';

const Logo = (props: { style: any; includeTitle: boolean }) => {
  const { style, includeTitle } = props;
  return (
    <Link style={style} to="/home">
      <img 
        style={style} 
        alt="logo" 
        className="tw-h-auto tw-w-auto" 
        src={includeTitle ? logo : simpleLogo}
      />
    </Link>
  );
};

export default Logo;
